import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  SectionTitle,
  EditorWrapper,
  Label,
  LabelText,
} from "../styles/form-styles";

class JobDescription extends Component {
  constructor(props) {
    super(props);

    const baseEditorState =
      props.description === undefined
        ? EditorState.createEmpty()
        : EditorState.createWithContent(
            ContentState.createFromText(props.description)
          );

    this.state = {
      editorState: baseEditorState,
    };
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    const { descriptionEditorOnChange } = this.props;

    const handlePlaceholder = () => {
      if (window.innerWidth < 500) {
        return "We can see you’re on a mobile, so you can always add the description later if you prefer...";
      }
      return "Add job description...";
    };

    return (
      <Fragment>
        <SectionTitle>Job description</SectionTitle>
        <Label>
          <LabelText> Description </LabelText>
        </Label>
        <EditorWrapper>
          <Editor
            ref={this.editor}
            toolbarClassName="editor-toolbar"
            editorClassName="editor"
            editorState={editorState}
            placeholder={handlePlaceholder()}
            onEditorStateChange={this.onEditorStateChange}
            onChange={() => descriptionEditorOnChange(editorState)}
            toolbar={{
              options: ["inline", "list"],
              inline: {
                options: ["bold", "italic", "underline", "strikethrough"],
              },
              list: {
                options: ["unordered", "ordered"],
              },
            }}
          />
        </EditorWrapper>
      </Fragment>
    );
  }
}

JobDescription.propTypes = {
  descriptionEditorOnChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    description: PropTypes.string,
  }).isRequired,
  description: PropTypes.string,
};

JobDescription.defaultProps = {
  description: PropTypes.isNull,
};

export default JobDescription;
